export enum TomasWidgetType {
  widget = 'tws-experience-widget',
  shop = 'tws-experience-shop',
}
